import { defineMessages } from "react-intl";

/**
 * SFCC-11723 — i18n message catalog for the Learning Center module-player blocks
 * (`learning-center-module/*`). Centralizes every user-facing string so each is
 * defined once, picked up by `yarn translations` (FormatJS extract), and
 * overridable per-locale. Consumed via `useIntl().formatMessage(...)` in the
 * components; the toast message (rendered outside the React tree by
 * `react-hot-toast`) is read through the same `intl` instance held by the
 * calling component.
 *
 * Ids are namespaced `learningCenter.module.*` to match the project's dotted
 * message-id convention (see `app/lib/constants.ts`).
 */
const messages = defineMessages({
  guestLessonLimitNotice: {
    id: "learningCenter.module.guest_lesson_limit_notice",
    defaultMessage: "Guest users have a two lesson limit",
  },
  guestLessonLimitReached: {
    id: "learningCenter.module.guest_lesson_limit_reached",
    defaultMessage: "You have reached the lesson limit for guest users",
  },
  loadError: {
    id: "learningCenter.module.load_error",
    defaultMessage: "There was an error loading this module.",
  },
  selectModule: {
    id: "learningCenter.module.select_module",
    defaultMessage: "Please select a module",
  },
  moduleLoading: {
    id: "learningCenter.module.module_loading",
    defaultMessage: "Module loading…",
  },
  earnPointsInstructions: {
    id: "learningCenter.module.earn_points_instructions",
    defaultMessage: "Review lessons and pass quiz in order to earn points",
  },
  lessonCompleted: {
    id: "learningCenter.module.lesson_completed",
    defaultMessage: "Completed",
  },
  lessonGetStarted: {
    id: "learningCenter.module.lesson_get_started",
    defaultMessage: "Get Started",
  },
  signInToViewMore: {
    id: "learningCenter.module.sign_in_to_view_more",
    defaultMessage: "Sign In to View More",
  },
  continueToQuiz: {
    id: "learningCenter.module.continue_to_quiz",
    defaultMessage: "Continue: Quiz",
  },
  continueToLesson: {
    id: "learningCenter.module.continue_to_lesson",
    defaultMessage: "Continue: Lesson {lessonNumber}",
  },
  quiz: {
    id: "learningCenter.module.quiz",
    defaultMessage: "Quiz",
  },
  quizRequiredAnswer: {
    id: "learningCenter.module.quiz_required_answer",
    defaultMessage: "You need to select an answer",
  },
  quizSubmit: {
    id: "learningCenter.module.quiz_submit",
    defaultMessage: "Submit",
  },
  quizFailedHeading: {
    id: "learningCenter.module.quiz_failed_heading",
    defaultMessage: "Oops!",
  },
  quizFailedBody: {
    id: "learningCenter.module.quiz_failed_body",
    defaultMessage:
      "Let’s make sure you answer all of the questions correctly!",
  },
  quizPassedHeading: {
    id: "learningCenter.module.quiz_passed_heading",
    defaultMessage: "Congratulations!",
  },
  quizPassedBody: {
    id: "learningCenter.module.quiz_passed_body",
    defaultMessage: "You completed {moduleTitle}",
  },
  ctaRedoQuiz: {
    id: "learningCenter.module.cta_redo_quiz",
    defaultMessage: "Redo Quiz",
  },
  ctaSeeMyPoints: {
    id: "learningCenter.module.cta_see_my_points",
    defaultMessage: "See My Points",
  },
  ctaFindMyNextGoal: {
    id: "learningCenter.module.cta_find_my_next_goal",
    defaultMessage: "Find My Next Goal",
  },
  ctaReturnToGoal: {
    id: "learningCenter.module.cta_return_to_goal",
    defaultMessage: "Return to Goal",
  },
  ctaNextModule: {
    id: "learningCenter.module.cta_next_module",
    defaultMessage: "Next Module",
  },
  lessonProgressSaved: {
    id: "learningCenter.module.lesson_progress_saved",
    defaultMessage: "Progress saved.",
  },
  lessonProgressSaveError: {
    id: "learningCenter.module.lesson_progress_save_error",
    defaultMessage: "We couldn't save your progress. Please try again.",
  },
  nextStepError: {
    id: "learningCenter.module.next_step_error",
    defaultMessage: "We couldn't open the next step. Please try again.",
  },
  quizSaveError: {
    id: "learningCenter.module.quiz_save_error",
    defaultMessage: "We couldn't save your quiz result. Please try again.",
  },
});

export default messages;
